import React, { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { getLocaleCode } from '../../lib/helper/helper'
import { useServerCurrency } from '../../lib/hooks/useServerCurrency'

type Props = {
  productId: string
}

const GYGBookingEngine = ({ productId }: Props) => {
  const { i18n } = useTranslation('common')
  const { currency } = useServerCurrency()
  const localeCode = getLocaleCode(i18n.language as any)
  const [isClient, setIsClient] = useState(false)
  console.log('productId', productId)
  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) {
    return null
  }

  const partnerId = 'W60CGI8'
  const cmp = 's2s'
  const gygHref = 'https://widget.getyourguide.com/default/availability.frame'
  return (
    <div key={productId + localeCode} className="relative">
      <div
        data-gyg-href={gygHref}
        data-gyg-tour-id={productId}
        data-gyg-locale-code={localeCode}
        data-gyg-currency={currency}
        data-gyg-widget="availability"
        data-gyg-variant="vertical"
        data-gyg-partner-id={partnerId}
        data-gyg-cmp={cmp}
      ></div>
      <div
        className="absolute bottom-0 left-0 right-0 w-full bg-white z-40"
        style={{ height: '48px' }}
      ></div>
    </div>
  )
}

export default GYGBookingEngine
